/**
 *
 * CriticalIncidentServices
 *
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import {
  injectIntl,
  intlShape,
  FormattedMessage,
  FormattedHTMLMessage,
} from 'react-intl';
import { compose } from 'redux';
import injectSaga from 'utils/injectSaga';
import injectReducer from 'utils/injectReducer';
import { THERAPY_URL,BBDBAP } from 'utils/environment';
import { isEap } from 'containers/Dashboard/helpers';
import PortalLayout from 'components/PortalLayout';
import bbdLogoFr from 'images/pcCarePathBapFr.png';
import bbdLogo from 'images/pcCarePathBap.png';
import { fetchUser } from '../App/actions';
import { trackUserClick } from '../EmployeeResources/actions';
import Card from './Card';
import messages from './messages';
import reducer from '../EmployeeResources/reducer';
import saga from '../EmployeeResources/saga';
import styled from 'styled-components';
import PcEapLogo from 'images/pc-eap-eng-logo.png';
import PcEapLogoFr from 'images/pc-eap-fr-logo.png';

const Button = styled.button`
  border-radius: 20px;
  cursor: pointer;
  height: 40px;
  padding: 0 40px;
  font-family: "Montserrat", sans-serif;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.5px;
  outline: none;
  color: #ffffff;
  background-color: #ffffff;
  background-image: linear-gradient(to left, #e3546f, #ff6b8a);
  border: none;
`

const ButtonDiv = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 0px 0px 20px 0px;
`

// eslint-disable-next-line react/prefer-stateless-function
class FinancialLegal extends Component {
  render() {
    const {company} = this.props;
    const { intl } = this.props;
    return (
      <div>
        <Helmet>
          <title>{intl.formatMessage(messages.title)}</title>
          <meta name="description" content="Description of Health Navigation" />
        </Helmet>
        <PortalLayout activeTab="financial_legal">
          <Card>
            <h1>
              <FormattedMessage {...messages.title} />
            </h1>
            <p>
              <FormattedMessage {...messages.body1} />
            </p>
            <p>
              <FormattedMessage {...messages.body2} />
            </p>
            <ul>
              <li>
                <p>
                  <b>
                    <FormattedMessage {...messages.body3} />
                  </b>
                  <br />
                  <FormattedMessage {...messages.body4} />
                </p>
              </li>
              <li>
                <p>
                  <b>
                    <FormattedMessage {...messages.body5} />
                  </b>
                  <br />
                  <FormattedMessage {...messages.body6} />
                </p>
              </li>
            </ul>
            <p>
              <FormattedMessage {...messages.body7} />
            </p>
            <p>
              <FormattedMessage {...messages.body8} />
            </p>
            <p>
              <FormattedMessage {...messages.body9} />
              <br />
              <FormattedMessage {...messages.body10} />
            </p>
            {
              isEap(company) && !BBDBAP &&
              <ButtonDiv>
                <img
                  className="logo"
                  src={intl.locale === 'en' ? PcEapLogo : PcEapLogoFr}
                  alt="inkblot logo"
                />
                <a
                  href={`${THERAPY_URL}/redirect/${localStorage.getItem('token')}`}
                  target="_blank"
                  onClick={this.handleUserClick}
                >
                  <Button>
                    <FormattedMessage {...messages.findMyCare} />
                  </Button>
                </a>
              </ButtonDiv>
            }
            <p>
              <FormattedHTMLMessage tagName="p" {...messages.body11} />
            </p>
            <ul>
              <li><FormattedHTMLMessage tagName="p" {...messages.body12} /></li>
              <li><FormattedHTMLMessage tagName="p" {...messages.body13} /></li>
            </ul>
            {BBDBAP && 
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  flexDirection: 'column',
                  width: '100%',
                  gap: '20px',
                }}
              >
                <img
                  src={intl.locale === 'en' ? bbdLogo : bbdLogoFr}
                  alt="bbd bap logo"
                  style={{ width: '250px' }}
                />
                <a
                  href={`${THERAPY_URL}/redirect/${localStorage.getItem('token')}`}
                  target="_blank"
                  onClick={this.handleUserClick}
                >
                  <Button>
                    <FormattedMessage {...messages.findMyCare} />
                  </Button>
                </a>
              </div>
            }
          </Card>
        </PortalLayout>
      </div>
    );
  }
}

FinancialLegal.propTypes = {
  intl: intlShape,
  trackUserClick: PropTypes.func.isRequired,
  fetchUser: PropTypes.func,
  copmany: PropTypes.object,
};

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
    trackUserClick: values => dispatch(trackUserClick(values)),
    fetchUser: callback => dispatch(fetchUser(callback)),
  };
}

function mapStateToProps(state) {
  // eslint-disable-next-line prefer-destructuring
  const company = state.toJS().app.user.data.company;
  const status = state.toJS().app.user.data.people_care;
  return { company, status };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

const withReducer = injectReducer({ key: 'employee_resources', reducer });
const withSaga = injectSaga({ key: 'employee_resources', saga });

export default compose(
  withConnect,
  withReducer,
  withSaga,
)(injectIntl(FinancialLegal));
